/**
* @private
*/
import HlsStream from './HlsStream';

export default HlsStream;

/*if (process.env.device_family === 'browser' &&
  process.env.device_family === 'browser' &&
  process.env.application_runtime === 'es5') {
  // This line of code will be the runtime for browser
} else {
  // Everything else
}*/



// WEBPACK FOOTER //
// ./src/entry.js